import type { TransactionType, TransactionStatus, TransactionLabel } from "../types/user-transaction.entity";

export const transactionTypeStyles: Record<TransactionType, string> = {
  CREDIT: "bg-green-50 text-green-700 border border-green-100",
  DEBIT: "bg-red-50   text-red-700   border border-red-100",
  RESERVING: "bg-yellow-50 text-yellow-700 border border-yellow-100",
  HOLDING: "bg-indigo-50 text-indigo-700 border border-indigo-100",
};

export const transactionStatusStyles: Record<TransactionStatus, string> = {
  PENDING: "bg-amber-50  text-amber-700  border border-amber-100",
  FINALIZED: "bg-green-50  text-green-700  border border-green-100",
  CANCELLED: "bg-gray-50   text-gray-700   border border-gray-100",
  FAILED: "bg-red-50    text-red-700    border border-red-100",
};

// styles/transactionStyles.ts

export const transactionLabelStyles: Record<TransactionLabel, string> = {
  // Positive / Success (green)
  BOOKED_MEETING: "bg-green-50 text-green-700 border border-green-100",
  COMPLETED_MEETING: "bg-green-50 text-green-700 border border-green-100",
  MEETING_EXTENSION_PAYMENT: "bg-green-50 text-green-700 border border-green-100",
  MEETING_EXTENSION_PAYOUT: "bg-green-50 text-green-700 border border-green-100",
  TOP_UP: "bg-green-50 text-green-700 border border-green-100",
  KARMA_PURCHASE: "bg-green-50 text-green-700 border border-green-100",
  REWARD_FOR_CANCELLED_SESSION: "bg-green-50 text-green-700 border border-green-100",
  REGISTER_COINS: "bg-green-50 text-green-700 border border-green-100",
  REFERRAL_REWARD: "bg-green-50 text-green-700 border border-green-100",

  // Info / Neutral (blue or gray)
  UPCOMING_MEETING: "bg-blue-50 text-blue-700 border border-blue-100",
  DIRECT_CALL: "bg-blue-50 text-blue-700 border border-blue-100",
  LOUNGE_DIRECT_CALL: "bg-blue-50 text-blue-700 border border-blue-100",
  AI_PRACTICE: "bg-blue-50 text-blue-700 border border-blue-100",
  COMPLETE_PROFILE: "bg-gray-50 text-gray-700 border border-gray-100",
  LEFT_A_WORD_REFLECTION: "bg-gray-50 text-gray-700 border border-gray-100",

  // Warning (amber)
  REFUND_CANCELLED_MEETING: "bg-amber-50 text-amber-700 border border-amber-100",
  REFUND_EXPIRED_REQUEST: "bg-amber-50 text-amber-700 border border-amber-100",
  //   : 'bg-amber-50 text-amber-700 border border-amber-100',

  // Negative / Error (red)
  BOOKING_REQUEST: "bg-red-50 text-red-700 border border-red-100",
  REFUND_DECLINED_REQUEST: "bg-red-50 text-red-700 border border-red-100",
  REFUND_COACH_MISSED_MEETING: "bg-red-50 text-red-700 border border-red-100",
  MONEY_WITHDRAWAL: "bg-red-50 text-red-700 border border-red-100",
  CANCELLED_MEETING: "bg-red-50 text-red-700 border border-red-100",
  PARTIAL_PAYOUT_CANCELLED_MEETING: "bg-red-50 text-red-700 border border-red-100",
  FULL_PAYOUT_OF_CANCELLED_MEETING: "bg-red-50 text-red-700 border border-red-100",

  // Admin actions (distinctive dark style)
  ADMIN_SESSION_DEDUCTION: "bg-gray-800 text-white border border-gray-700",
  ADMIN_SESSION_REFUND: "bg-gray-800 text-white border border-gray-700",
};
